import styled from 'styled-components'

const TentativeScoringTableHeader = () => {
  return (
    <StyledWrapper>
      <tr>
        <th rowSpan={3}>문항 번호</th>
        <th rowSpan={3}>복원 답안</th>
        <th rowSpan={3}>내 답안</th>
      </tr>
      <tr>
        <th colSpan={5}>응시자 선택 비율</th>
      </tr>
      <tr>
        <th>①</th>
        <th>②</th>
        <th>③</th>
        <th>④</th>
        <th>⑤</th>
      </tr>
    </StyledWrapper>
  )
}

export default TentativeScoringTableHeader

const StyledWrapper = styled.thead`
  > tr {
    &:first-child {
      & > th:first-child {
        border-left: 0;
      }
    }

    > th {
      height: 52px;
      background-color: #fafafa;
      border: solid 1px #eeeeee;
      border-collapse: collapse;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.64px;
      text-align: center;
      vertical-align: middle;
      color: #333;

      &:last-child {
        border-right: 0;
      }
    }
  }
`
